import React, { Suspense, useCallback, useMemo } from 'react';

import { ModalResponsiveTableRequestProvider } from './components/ModalResponsiveTableRequestV2';
import {
  ContentTabsProps,
  TabsViewsProvider,
} from './components/ResponsiveTableV2/components/TabsViews';
import { DashboardCardProps, DashboardCardTypeEnum } from './localGeneric';
import Type from './types';

const DashboardCard: React.FC<DashboardCardProps> = (props) => {
  const { type } = props;

  const Card = useCallback(() => {
    switch (type) {
      case DashboardCardTypeEnum.PYRAMID_CHART:
        return <Type.PyramidChart {...props} />;
      case DashboardCardTypeEnum.DONUT_CHART:
        return <Type.DonutChart {...props} />;
      case DashboardCardTypeEnum.MULTIPLES_DONUTS_CHART:
        return <Type.MultipleDonutsChart {...props} />;
      case DashboardCardTypeEnum.BAR_CHART:
        return <Type.BarChart {...props} />;
      case DashboardCardTypeEnum.LINE_CHART:
        return <Type.LineChart {...props} />;
      case DashboardCardTypeEnum.BAR_LINE_CHART:
        return <Type.BarLineChart {...props} />;
      case DashboardCardTypeEnum.RADAR_CHART:
        return <Type.RadarChart {...props} />;
      case DashboardCardTypeEnum.HEATMAP_CHART:
        return <Type.HeatmapChart {...props} />;
      case DashboardCardTypeEnum.GAUGE_CHART:
        return <Type.GaugeChart {...props} />;
      case DashboardCardTypeEnum.GAUGE_CHART_V2:
        return <Type.GaugeChartV2 {...props} />;
      case DashboardCardTypeEnum.RESPONSIVE_LIST:
        return <Type.ResponsiveList {...props} />;
      case DashboardCardTypeEnum.RESPONSIVE_TABLE:
        return <Type.ResponsiveTable {...props} />;
      case DashboardCardTypeEnum.RESPONSIVE_TABLE_TEXT:
        return <Type.ResponsiveTableText {...props} />;
      case DashboardCardTypeEnum.TABLE:
        return <Type.Table {...props} />;
      case DashboardCardTypeEnum.LIST:
        return <Type.List {...props} />;
      case DashboardCardTypeEnum.SIMPLE_TEXT:
        return <Type.SimpleText {...props} />;
      case DashboardCardTypeEnum.RESPONSIVE_TABLE_MULTI:
        return <Type.ResponsiveTableMulti {...props} />;
      case DashboardCardTypeEnum.PHOTO_BOOK:
        return <Type.PhotoBook {...props} />;
      case DashboardCardTypeEnum.HEADER:
        return <Type.Header {...props} />;
      case DashboardCardTypeEnum.TABS:
        return <Type.Tabs {...props} />;
      case DashboardCardTypeEnum.MAP:
        return <Type.Map {...props} />;
      case DashboardCardTypeEnum.FILTER_CARD:
        return <Type.FilterCard {...props} />;
      case DashboardCardTypeEnum.FRAME_CARD:
        return <Type.FrameCard {...props} />;
      case DashboardCardTypeEnum.BIG_CALENDAR:
        return <Type.BigCalendar {...props} />;
      case DashboardCardTypeEnum.GOOGLE_MAP:
        return <Type.GoogleMap {...props} />;
      case DashboardCardTypeEnum.GOOGLE_MAP_GENERAL_INSPECTION:
        return <Type.GoogleMapV2 {...props} />;
      case DashboardCardTypeEnum.AREA_BUMP:
        return <Type.AreaBumpChart {...props} />;
      case DashboardCardTypeEnum.AUDIT_CARD:
        return <Type.Audit {...props} />;
      case DashboardCardTypeEnum.TICKET_CARD:
        return (
          <Type.Tickets
            autoFlowId="0afeb353-7e77-4394-ba6e-2a088e5a98b5"
            {...props}
          />
        ); // NOTE - gambiarra
      case DashboardCardTypeEnum.PROGRESS_BAR:
        return <Type.ProgressBar {...props} />;
      case DashboardCardTypeEnum.MULTI_CARD:
        return <Type.MultiCardComponent {...props} />;
      default:
        return <Type.DefaultCard {...props} />;
    }
  }, [props, type]);

  const CardMemo = useMemo(() => Card(), [Card]);

  return (
    <Suspense fallback={<></>}>
      <TabsViewsProvider value={props as ContentTabsProps}>
        <ModalResponsiveTableRequestProvider value={{ ...props }}>
          {CardMemo}
        </ModalResponsiveTableRequestProvider>
      </TabsViewsProvider>
    </Suspense>
  );
};

export default DashboardCard;
